import React from "react";

import { IPackage, IStudent, IClass } from "../../../state";
import Questionnaire from "../../../organisms/student/Questionnaire";
import { generateFullName } from "../../../libs/Util";
import Button from "../../../atoms/Button";

import styles from "./QuestionnaireList.module.scss";

export interface IQuestionnaireProps {
  student: IStudent;
  currentClass: IClass;
  packageQuestion: IPackage[];
  directTo: (teaching_material_id: number) => void;
  goBack: () => void;
}

export const QuestionnaireList = (props: IQuestionnaireProps) => {
  return (
    <>
      <div className={styles.info}>
        <p className={styles.class}>
          {generateFullName([
            props.student?.last_name_kana,
            props.student?.first_name_kana,
          ])}
        </p>
        <p className={styles.name}>
          {generateFullName([
            props.student?.last_name,
            props.student?.first_name,
          ])}
        </p>
        <p className={styles.class}>クラス: {props.currentClass.full_name}</p>
      </div>
      <Button
        name="クラスに戻る"
        variant="normal"
        className={styles.btnBackToClassList}
        onClick={props.goBack}
      />
      <div className={styles.wrapper} id="accordion">
        {props.packageQuestion.map(question => (
          <Questionnaire
            key={question.id}
            packageQuestion={question}
            directTo={props.directTo}
          />
        ))}
      </div>
    </>
  );
};

export default QuestionnaireList;
